import { useState } from "react";
import { Button, Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";

export const EmptyState = () => {
  const [trackedDisplay, setTrackedDisplay] = useState(false);

  const { track } = useAnalyticsContext();
  const utmSource =
    new URLSearchParams(window.location.search).get("platform") || "unknown";
  const ajs_aid = window.rudderanalytics.getAnonymousId();

  if (!trackedDisplay) {
    track("Component Viewed", {
      locationIdentifier: "hltv_empty_state",
      location: "embeddable_playlist",
    });
    setTrackedDisplay(true);
  }

  return (
    <StyledEmptyState>
      <StyledHeader
        variant="headingSmall"
        mb={2}
        color="ice"
        textAlign="center"
      >
        We're still working on these clips, but we've got trending clips to
        watch right now!
      </StyledHeader>
      <StyledSubText
        variant="subheader"
        mb={3}
        color="chalk"
        sx={{ textAlign: "center", maxWidth: 320 }}
      >
        Watch any of the playlists below to see the top trending HTLV clips on
        Allstar.gg right now.
      </StyledSubText>
      <StyledEmptyStateButton
        as="a"
        href={`https://allstar.gg/match-history?utm_source=${utmSource}&ajs_aid=${ajs_aid}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          track("Button - Click", {
            locationIdentifier: "empty_state_button",
            location: "embeddable_playlist",
          });
        }}
      >
        <StyledButtonText variant="labelMedium" color="ice">
          Watch Now
        </StyledButtonText>
      </StyledEmptyStateButton>
    </StyledEmptyState>
  );
};

const StyledEmptyState = styled(Flex)`
  align-items: center;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  min-height: 100%;
  width: 95vw;
`;

const StyledEmptyStateButton = styled(Button)`
  background: ${({ theme }) => theme.colors.envy};
  border-radius: 24px;
  border: none;
  color: #fff;
  cursor: pointer;
  margin-top: 16px;
  padding: 10px 32px;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.envyAlpha80};
  }

  @media (max-height: 350px) {
    margin-top: 0;
  }

  @media (max-height: 300px) {
    padding: 5px 10px;
  }

  @media (max-height: 250px) {
    display: none;
  }
`;

const StyledHeader = styled(Text)`
  @media (max-height: 350px) {
    font-size: 20px;
    line-height: 22px;
  }

  @media (max-height: 300px) {
    font-size: 14px;
    line-height: 16px;
  }
`;

const StyledSubText = styled(Text)`
  @media (max-height: 350px) {
    font-size: 0.75em;
    line-height: 1.25em;
  }

  @media (max-height: 300px) {
    font-size: 0.65em;
    line-height: 1em;
    margin-bottom: 5px;
  }
`;

const StyledButtonText = styled(Text)`
  @media (max-height: 300px) {
    font-size: 12px;
    line-height: 14px;
  }
`;
